import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  openDrawer: true,
  swipeEdge: false,
  users: [],
  total: 0,
  hasNextPage: true,
  isFetching: false,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState: initialState,
  reducers: {
    resetSearch: (state, action) => {
      state.users = [];
      state.total = 0;
      state.hasNextPage = true;
    },
    searchPending: state => {
      state.isFetching = true;
    },
    searchFulfilled: (state, action) => {
      const { employeeProfiles, totalCount } = action.payload;
      state.total = totalCount;
      state.users = state.users.concat(employeeProfiles);
      state.hasNextPage = state.users.length < state.total;
      state.isFetching = false;
    },
    setDrawer: (state, action) => {
      const { value } = action.payload;
      state.openDrawer = value;
    },
    toggleSwipe: (state, action) => {
      const { value } = action.payload;
      state.swipeEdge = value;
    },    
  },
  extraReducers (builder) {},
});

export const selectUsers = state => {
  return state.search.users;
};
export const selectTotal = state => {
  return state.search.total;
};
export const selectHasNextPage = state => {
  return state.search.hasNextPage;
};
export const selectFetching = state => {
  return state.search.isFetching;
};
export const selectDrawerOpen = state => {
  return state.search.openDrawer;
};
export const selectSwipeEdge = state => {
  return state.search.swipeEdge;
};

export const { resetSearch, searchFulfilled, searchPending, setDrawer, toggleSwipe } = searchSlice.actions;
export default searchSlice.reducer;
